// 用来管理我们的上传数据，供组件调用
// 管理上传数据信息

// 上传服务器状态层
import { message } from 'antd';
import { action, observable } from 'mobx';
import { Uploader } from '../models';

class ImageStore {
    @observable filename = "";
    @observable file = null;
    @observable isUploading = false;
    @observable serverFile = null;

    @action setFilename(newFilename) {
        this.filename = newFilename;
    }
    @action setFile(newFile) {
        this.file = newFile;
    }

    @action upload() {
        this.isUploading = true;
        // 上传之前，清空原先的图片
        this.serverFile = null;
        //为了在后续的UI组件中可以用到状态， 我们可以返回Promise
        return new Promise((resolve, reject) => {
            Uploader.add(this.file, this.filename)
                .then(serverFile => {
                    this.serverFile = serverFile;
                    resolve(serverFile);
                }).catch((err) => {
                    // console.log(err);
                    message.error('上传失败！')
                }).finally(() => {
                    this.isUploading = false;
                })
        })

    }
    @action reset() {
        this.isUploading = false;
        this.serverFile = null;
    }

}

export default new ImageStore();

